import { lazy } from 'react';

const Leads = lazy(() => import('./AgentLeadsPage'));

const AgentLeadsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/agent/leads',
      element: <Leads />,
    },
  ],
};

export default AgentLeadsConfig;
